import { EMAIL_REGEX } from "@zenith/data/constants";

export const setEstimatedAnnualTurnoverValidation = (
  estimatedAnnualTurnover: string
) => {
  const hasError = false;
  const message = "";

  if (estimatedAnnualTurnover === "") {
    return {
      hasError: true,
      message: "Estimated Annual Turnover is required",
    };
  }
  return {
    hasError,
    message,
  };
};

export const setStaffSizeValidation = (staffStrength: string) => {
  const hasError = false;
  const message = "";

  if (staffStrength === "") {
    return {
      hasError: true,
      message: "Staff Size is required",
    };
  }
  return {
    hasError,
    message,
  };
};
